import React from 'react'
import styled from 'styled-components'
import {
  position,
  flexbox,
  space,
  layout,
  color
} from 'styled-system'
import { GatsbyImage } from 'gatsby-plugin-image'

export const StyledGatsbyImage = styled(GatsbyImage)`
  ${position}
  ${flexbox}
  ${space}
  ${layout}
  ${color}
`

const Image = props => {
  return (
    <StyledGatsbyImage {...props} />
  )
}

export default Image